export default __webpack_public_path__ + "static/media/3.16756f9e.png";